import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const reporting = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/reportingColorIcon.svg" alt="Reporting" />
            <p>{applicationTitles.reporting}</p>
        </div>
    );
};

export default reporting;
